import * as motion from "motion/react-client";

export default function ScrollTriggered({ datas }) {
  return (
    <div style={container}>
      {/* {food.map(([emoji, hueA, hueB], i) => (
        <Card i={i} emoji={emoji} hueA={hueA} hueB={hueB} key={emoji} />
      ))} */}
      {datas?.map((v, i) => {
        return <Card key={i} v={v} i={i} />;
      })}
    </div>
  );
}

function Card({ v, i }) {
  const background = `linear-gradient(306deg, rgb(199, 33, 33), #ffcd45)`;

  return (
    <motion.div
      className={`card-container-${i}`}
      style={cardContainer}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ amount: 0.8 }}
    >
      <div style={{ ...splash, background }} />
      <motion.div style={card} variants={cardVariants} className="card">
        <div className="p-4">
          <h2 className="text-xl  font-semibold py-0.5">{v?.heading}</h2>
          <p className="text-white py-0.5 text-md">{v?.description}</p>
        </div>
      </motion.div>
    </motion.div>
  );
}

const cardVariants = {
  offscreen: {
    y: 300, // Moves card further down
    opacity: 0, // Initially hidden
  },
  onscreen: {
    y: 50, // Moves card back to normal
    opacity: 1, // Fades in
    rotate: -10,
    transition: {
      type: "spring",
      bounce: 0.4,
      duration: 0.8,
    },
  },}

const container = {
  margin: "100px auto",
  maxWidth: 500,
  paddingBottom: 100,
  width: "100%",
};

const cardContainer = {
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  paddingTop: 20,
  marginBottom: -120,
};

const splash = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  clipPath: `path("M 0 303.5 C 0 292.454 8.995 285.101 20 283.5 L 460 219.5 C 470.085 218.033 480 228.454 480 239.5 L 500 430 C 500 441.046 491.046 450 480 450 L 20 450 C 8.954 450 0 441.046 0 430 Z")`,
};

const card = {
  fontSize: 16,
  width: 300,
  height: 430,
  borderRadius: 15,
  background: "#f7931f",
  boxShadow:
    "0 0 1px hsl(0deg 0% 0% / 0.075), 0 0 2px hsl(0deg 0% 0% / 0.075), 0 0 4px hsl(0deg 0% 0% / 0.075), 0 0 8px hsl(0deg 0% 0% / 0.075), 0 0 16px hsl(0deg 0% 0% / 0.075)",
  transformOrigin: "5% 55%",
};
